<template>
  <div class="ccd-overlay" @click.self="cancel">
    <div
      class="card ccd-card"
      role="alertdialog"
      aria-modal="true"
      :aria-label="title"
    >
      <div class="card-head">
        <h3>{{ title }}</h3>
        <button class="ccd-x" aria-label="Fechar" @click="cancel">
          ✕
        </button>
      </div>

      <!-- Slot permite destacar trechos da mensagem (ex.: <strong>) -->
      <p class="ccd-msg">
        <slot>{{ message }}</slot>
      </p>

      <div class="ccd-actions">
        <button
          class="btn btn--outline btn--sm ccd-btn"
          :disabled="loading"
          @click="cancel"
        >
          {{ cancelLabel }}
        </button>
        <button
          class="btn btn--sm ccd-btn"
          :class="`btn--${variant}`"
          :disabled="loading"
          @click="$emit('confirm')"
        >
          {{ loading ? "Aguarde…" : confirmLabel }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
// Diálogo genérico de confirmação do ambiente de clínica, pra ações que o
// recepcionista pode disparar por engano (ex.: reagendar a consulta errada).
export default {
  name: "ClinicConfirmDialog",
  props: {
    title: { type: String, required: true },
    message: { type: String, default: "" },
    confirmLabel: { type: String, default: "Confirmar" },
    cancelLabel: { type: String, default: "Voltar" },
    // Variante do botão de confirmação (primary, danger, success…)
    variant: { type: String, default: "primary" },
    loading: { type: Boolean, default: false }
  },
  mounted() {
    document.addEventListener("keydown", this.onKeydown);
  },
  beforeDestroy() {
    document.removeEventListener("keydown", this.onKeydown);
  },
  methods: {
    cancel() {
      if (!this.loading) this.$emit("close");
    },
    onKeydown(e) {
      if (e.key === "Escape") this.cancel();
    }
  }
};
</script>

<style lang="scss" scoped>
.ccd-overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.5);
  z-index: 80;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--space-5);
}
.ccd-card {
  width: 100%;
  max-width: 420px;
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
}
.ccd-card .card-head h3 {
  font-size: var(--font-size-lg);
}
.ccd-x {
  border: none;
  background: none;
  color: var(--color-gray-400);
  font-size: var(--font-size-md);
  cursor: pointer;
  &:hover {
    color: var(--color-gray-700);
  }
}
.ccd-msg {
  font-size: var(--font-size-md);
  line-height: 1.5;
  color: var(--color-gray-600);
  margin: 0;
  strong {
    color: var(--color-gray-900);
    font-weight: var(--fw-semibold);
  }
}
.ccd-actions {
  display: flex;
  justify-content: flex-end;
  gap: var(--space-3);
}
// .btn--sm do DS usa !important; aqui o botão fica um pouco maior pra leitura
.ccd-btn {
  height: 40px !important;
  font-size: var(--font-size-sm) !important;
}
</style>
